/**
 * Response object describing a downloaded file data
 */
export interface DownloadedFile {
    /** downloaded Blob data */
    blob: Blob;
    /** Filename from Headers */
    filename: string | null;
}

/**
 * Remove property "durationMillis" from JSON response (if existing).
 * @param result result to remove "durationMillis"
 * @return copy of the JSON Object without the property; Arrays unverändert, ein Spread würde sie zum Objekt machen
 */
export function removeAdminDuration(result: any): any {
    if (typeof result !== "object" || result === null || Array.isArray(result)) return result;
    const {durationMillis, ...rest} = result;
    return rest;
}

/**
 * Remove specific property key form a JSON
 * @param result result to remove key from
 * @param key key to remove
 * @return copy of the JSON Object without the property
 */
export function removeResponseValue(result: any, key: string): any {
    if (typeof result !== "object" || result === null || typeof result[key] === "undefined") return result;
    const removed = {...result};
    delete removed[key];
    return removed;
}

/**
 * Remove specific property keys form a JSON
 * @param result result to remove key from
 * @param keys keys to remove
 * @return copy of the JSON Object without the properties
 */
export function removeResponseValues(result: any, keys: string[]): any {
    if (typeof result !== "object" || result === null) return result;
    const removed = {...result};
    for (const key of keys) {
        delete removed[key];
    }
    return removed;
}
